var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["p"], 
["options"], 
function (l_p, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("p", l_p);
frame.set("options", kwargs.hasOwnProperty("options") ? kwargs["options"] : {});
var t_2 = "";t_2 += "<li class=\"ProjectItem ";
frame = frame.push();
var t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "options")),"modifiers");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("m", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
t_2 += "ProjectItem--";
t_2 += runtime.suppressValue(t_6, env.opts.autoescape);
;
}
}
frame = frame.pop();
t_2 += "\">\n        <a href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"url"), env.opts.autoescape);
t_2 += "\" class=\"ProjectItem-link\">\n            <span class=\"ProjectItem-imgContainer\">\n                <img src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"tn"), env.opts.autoescape);
t_2 += "\" srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_p),"img")),"tn_2x"), env.opts.autoescape);
t_2 += " 2x\" alt=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((l_p),"title"), env.opts.autoescape);
t_2 += "\" class=\"ProjectItem-img\">\n                <span class=\"Frame\">\n                    <span class=\"Frame-side Frame-side--right\"></span>\n                    <span class=\"Frame-side Frame-side--bottom\"></span>\n                </span>\n            </span>\n\n            <span class=\"ProjectItem-fake\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"title")), env.opts.autoescape);
t_2 += "\n            </span>\n\n            <span class=\"ProjectItem-text\">\n                <span class=\"ProjectItem-title\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"title")), env.opts.autoescape);
t_2 += "</span>\n                <span class=\"ProjectItem-intro\">";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((l_p),"authors")), env.opts.autoescape);
t_2 += "</span>\n            </span>\n        </a>\n    </li>\n    ";
t_2 += runtime.suppressValue((lineno = 21, colno = 11, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("ProjectItem");
context.setVariable("ProjectItem", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectItem.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProjectItem/ProjectItem.jinja
// module id = 47
// module chunks = 0